/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as TYPES from "./action-types";
const intialState = {
  loading: false,
  userDefault: null,
  rebateDropdownData: [],
  deleteBatchFilter: {},
  errorMessages: [],
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.DELETE_BATCH_LOADING:
      return { ...state, loading: action.payload };
    case TYPES.DELETE_BATCH_REBATE_PROGRAM_DATA:
      return { ...state, rebateDropdownData: action.payload };
    case TYPES.DELETE_BATCH_FILTER:
      return { ...state, deleteBatchFilter: action.payload };
    case TYPES.DELETE_BATCH_USERDEFAULT:
      return { ...state, userDefault: action.payload };
    case TYPES.DELETE_BATCH_RESET_STORE:
      return { ...intialState };
    case TYPES.SET_ERROR_MESSAGE:
      return { ...state, errorMessages: action.payload };
    default:
      return state;
  }
};

export default reducer;
